import { useAtomValue } from 'jotai'
import { useAtomCallback } from 'jotai/utils'
import { useCallback, type FC } from 'react'

import { Modal } from '@/components/elements'
import { MENU } from '@/constants/common/message.constants'

import { isOpenTourCsvImportModalAtom } from '../../-states'

import { TourCsvImportModalContent } from './TourCsvImportModalContent'

type Props = {
  tenantKey: string
}

/**
 * 運行実績CSVインポートModal
 */
export const TourCsvImportModal: FC<Props> = ({ tenantKey }) => {
  const isOpen = useAtomValue(isOpenTourCsvImportModalAtom)

  const handleSuccess = useAtomCallback(
    useCallback(async (_, set) => {
      set(isOpenTourCsvImportModalAtom, false)
    }, [])
  )

  const handleCancel = useAtomCallback(
    useCallback((_, set) => {
      set(isOpenTourCsvImportModalAtom, false)
    }, [])
  )

  return (
    <Modal
      title={MENU.TOUR_CSV_IMPORT}
      width={580}
      open={isOpen}
      onCancel={handleCancel}
    >
      <TourCsvImportModalContent
        tenantKey={tenantKey}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </Modal>
  )
}
